import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../styles/footer.css';
import { BsPhone } from 'react-icons/bs';
import { MdOutlineMailOutline } from 'react-icons/md';
import GoogleMapReact from 'google-map-react';

const Marker = ({ text }) => (
  <div style={{ color: 'black', fontWeight: 'bold' }}> &#x25cf; {text}</div>
);

function Footer() {
  const defaultProps = {
    center: {
      lat: 35.46948,
      lng: -97.50636461496995,
    },
    zoom: 11,
  };

  const year = new Date().getFullYear();

  return (
    <Container
      fluid
      className="w-100 footer"
      style={{ '--bs-gutter-x': '0rem' }}
    >
      <div className="info-div">
        <div className="info-child">
          <h4>Datagenetx</h4>

          <div>
            322 N.E 2nd Street <br />
            2nd Floor <br />
            Oklahoma City, OK 73104
          </div>
        </div>
        <div className="info-child">
          <h4>Contact Us</h4>

          <div className="contact-us">
            <div className="footer-icon">
              <BsPhone />
            </div>
            <a href="tel:4054559053">(405) 455-9053</a>
          </div>

          <div className="contact-us">
            <div className="footer-icon">
              <MdOutlineMailOutline />
            </div>
            <a href="mailto:info@datagenetx.com">info@datagenetx.com</a>
          </div>
        </div>
        <div className="info-child" style={{ width: '250px', height: '250px' }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
          >
            <Marker
              lat={35.46947850194029}
              lng={-97.50636461496995}
              text="Datagenetx"
            />
          </GoogleMapReact>
        </div>
      </div>

      <div className="footerBottom d-flex text-center justify-content-center">
        <a target="_blank" href="https://qualfon.com/privacy-policy/">Privacy Policy</a> &nbsp;| &copy; {year} &nbsp;{' '}
        <a
          style={{ textDecoration: 'underline' }}
          href="https://www.leadvisionmedia.com/"
        >
          LeadVision Media LLC.
        </a>
      </div>
    </Container>
  );
}

export default Footer;
